import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Alert, Button } from '../ui';

interface RouteErrorBoundaryProps {
    children: ReactNode;
    routeName: string;
}

interface RouteErrorBoundaryState {
    hasError: boolean;
}

export class RouteErrorBoundary extends Component<RouteErrorBoundaryProps, RouteErrorBoundaryState> {
    state: RouteErrorBoundaryState = {
        hasError: false,
    };

    static getDerivedStateFromError(): RouteErrorBoundaryState {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: ErrorInfo): void {
        console.error(`[RouteErrorBoundary] ${this.props.routeName}`, error, info.componentStack);
    }

    private handleRetry = () => {
        this.setState({ hasError: false });
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="flex flex-1 flex-col gap-3 px-4 py-6">
                    <Alert
                        type="error"
                        message={`No se pudo renderizar la pantalla "${this.props.routeName}".`}
                    />
                    <p className="text-sm text-text-muted">
                        Esto suele pasar cuando un dato del servidor llega incompleto o el build del dispositivo no coincide con el flujo esperado.
                    </p>
                    <div className="flex gap-2">
                        <Button type="button" onClick={this.handleRetry}>
                            Reintentar
                        </Button>
                        <Button type="button" variant="ghost" onClick={() => window.location.reload()}>
                            Recargar app
                        </Button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}
